module.exports = __webpack_public_path__ + "img/list-line.68644d19.svg";